function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke:#5A7A7D;stroke-width:50;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#FFFFFF;stroke:#5A7A7D;stroke-width:50;stroke-linecap:round;stroke-linejoin:round;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "f84a7768-9a55-4f29-9b82-eca33729bc38"
}, /*#__PURE__*/React.createElement("g", {
  id: "aa99569a-2f87-43fe-a9c3-2d64172598c4"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M684.3,666.6c-0.3,13-3.4,26.7,0.7,40.5c1.7,2.3,3.2,5.5,6,7c31.7-22.6,58.1-51,89.8-73.6 c5.4-9.3,15.1-12.9,22.3-21c4.7-4.4,9.1-6.7,13.6-10.1c1.1-0.8,1.4-2.8,2.6-3.7c16.2-13.8,31.1-25.7,46.5-40.6 c2.1-0.7,3.4-2.5,5.7-4.2c16.6-9.7,35.1-12,52.5-6.4c20.3,6,37.8,17.7,50.4,34.8c16.7,23.7,15.8,56.9-3.8,80.3 c-9.8,11.7-19.2,20.4-29,32.1c-37.1,39-70.1,70.5-107.2,109.5c-14.5,16-27.6,29.3-42.9,44.2c-21.5,22.1-39.7,42.6-60.3,65.9 c-9.8,11.7-19.3,21.4-29.2,33.1c-1.3,1.8-1.4,2.8-2.7,4.7c-9.5,9.7-16.9,18.7-26.5,28.4c-1.3,1.8-1.4,2.8-2.7,4.7 c-9.5,9.7-16.9,18.7-26.5,28.4c-1.3,1.8-1.4,2.8-2.7,4.7c-9.7,10.7-18.2,20.6-27.9,31.2c-2.3,1.7-4.5,3.4-5.8,5.2 c-1.4,2.8-4,6.5-4.4,9.5c-2.1,13.8-5.1,27.6-5.6,41.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M273.8,576L137.1,314.5c-10.6-27.1-41-40.5-68.1-30.1l-10.3,4c-27.1,10.5-40.5,41-30.1,68.1l101,288.8 l41,246.8l88.8,205.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M423.1,965.2c2.4-59.3,44.3-108.2,90.5-142.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M454.1,434.5l-14.3,3.6c-31.5,7.8-50.9,38.6-43.3,68.3l52.1,201.4c7.7,29.7,39.7,47.7,71.2,39.8l14.3-3.5 c31.5-7.8,50.9-38.6,43.2-68.4l-52.1-201.4C517.7,444.5,485.6,426.6,454.1,434.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M599.8,416.2l-14.2,3.7c-31.6,8.1-50.6,40.2-42.7,71.8L597,704.8c8.1,31.5,40.1,50.6,71.7,42.7l14.3-3.6 c31.5-8.1,50.6-40.2,42.7-71.8L671.6,459C663.5,427.4,631.4,408.3,599.8,416.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M314.5,430.2l-14.3,3.5c-31.5,7.7-51.1,37.7-43.6,66.5l51.1,195c7.5,28.8,39.5,46,71,38.3l14.2-3.5 c31.5-7.8,51.1-37.7,43.5-66.5l-51-195C377.9,439.7,346,422.5,314.5,430.2z"
})));

function SvgRight6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "adb5c1c0-6a8b-484d-88e4-77f8aefd378a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1013.2 1163.8",
    style: {
      enableBackground: "new 0 0 1013.2 1163.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight6);
export default __webpack_public_path__ + "static/media/right-6.2203ca82.svg";
export { ForwardRef as ReactComponent };